import {createContext} from 'react'

import {SignUpMode} from '../types/types'

export default createContext<SignUpMode>('free-trial')
